import type { ContactDetailPlatformProfile, PlatformTypeName } from "@multi-chat/shared";

export type ContactChannelIdentity = {
  profileId: number;
  platformType: PlatformTypeName;
  /** Phone for WhatsApp, @username for Instagram, the provider name otherwise; null when absent. */
  identity: string | null;
  conversationId: number | null;
};

/** The identity a provider uses to address this profile. */
export function contactProfileIdentity(profile: ContactDetailPlatformProfile): string | null {
  const phone = profile.normalizedPhoneNumber?.trim() || null;
  const username = profile.platformUsername?.trim() || null;
  const name = profile.platformDisplayName?.trim() || null;
  switch (profile.platformType) {
    case "WHATSAPP":
      return phone ?? name;
    case "INSTAGRAM":
      return username ? `@${username.replace(/^@/, "")}` : name;
    case "FACEBOOK":
      return name ?? username;
    default: {
      const _exhaustive: never = profile.platformType;
      return _exhaustive;
    }
  }
}

export function contactChannelIdentities(
  profiles: readonly ContactDetailPlatformProfile[],
): ContactChannelIdentity[] {
  return profiles.map((profile) => ({
    profileId: profile.id,
    platformType: profile.platformType,
    identity: contactProfileIdentity(profile),
    conversationId: profile.conversationId,
  }));
}

/** The contact's other channel profiles, excluding the one behind the open conversation. */
export function linkedContactIdentities(
  profiles: readonly ContactDetailPlatformProfile[],
  currentProfileId: number,
): ContactChannelIdentity[] {
  return contactChannelIdentities(profiles.filter((profile) => profile.id !== currentProfileId));
}
